<template>
  <section class="page">
    <div class="page__header">
      <div class="page__title">
        <SharedBreadcrumbs :breadcrumbs />

        <FaqSearch />
      </div>

      <h1 class="typography__headline1">Регистрация и&nbsp;начало работы</h1>
    </div>

    <div class="page__content">
      <FaqArticlesAside :menu />

      <FaqArticlesContent>
        <div class="base-content-block">
          <FaqArticlesBlockHeading
            id="avtorizatsiya"
            class="typography__headline2"
          >
            Авторизация
          </FaqArticlesBlockHeading>

          <div class="block-small">
            <p>
              Чтобы начать работу в&nbsp;MyDonut, авторизуйтесь на&nbsp;сайте
              <BaseLink
                :href="createAppLink('/', 'main')"
                rel="noopener noreferrer"
                target="_blank"
                >mydonut.app
              </BaseLink>
              .
            </p>

            <p>
              Пройдите
              <BaseLink
                :href="createAppLink('/?modal=modal-auth-registration', 'main')"
                rel="noopener noreferrer"
                target="_blank"
                >регистрацию
              </BaseLink>
              нажав кнопку &laquo;Зарегистрироваться&raquo; в&nbsp;шапке сайта или &laquo;Попробовать бесплатно&raquo;
              ниже.
            </p>

            <p>
              <BaseLink
                :href="createAppLink('/?modal=modal-auth-login', 'main')"
                rel="noopener noreferrer"
                target="_blank"
                >Войдите </BaseLink
              >, нажав на&nbsp;&laquo;Войти&raquo; в&nbsp;шапке сайта.
            </p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/registratsiya-i-nachalo-raboty-1.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <p>
            Войти или зарегистрироваться можно с&nbsp;помощью электронной почты и&nbsp;пароля. Также удобно
            и&nbsp;быстро авторизоваться через предложенные сервисы.
          </p>

          <FaqArticlesImageModalButton
            class="image-size-600"
            image-source="/images/faq/registratsiya-i-nachalo-raboty-2.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <div class="block-small">
            <p>
              Если забыли пароль&nbsp;&mdash; нажмите &laquo;Не&nbsp;помню пароль&raquo; под полем ввода пароля
              и&nbsp;введите в&nbsp;появившемся окне электронную почту от&nbsp;вашего аккаунта.
            </p>

            <p>
              На&nbsp;указанную почту будет отправлено письмо с&nbsp;ссылкой для восстановления пароля, перейдя
              по&nbsp;которой нужно будет придумать новый пароль.
            </p>
          </div>

          <FaqArticlesImageModalButton
            class="image-size-600"
            image-source="/images/faq/registratsiya-i-nachalo-raboty-3.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />
        </div>

        <div class="base-content-block">
          <FaqArticlesBlockHeading
            id="podtverzhdenie-akkaunta"
            class="typography__headline2"
          >
            Подтверждение аккаунта
          </FaqArticlesBlockHeading>

          <div class="block-small">
            <p>
              После успешной авторизации вы&nbsp;попадёте в&nbsp;интерфейс MyDonut на&nbsp;домашнюю страницу вашего
              аккаунта.
            </p>

            <p>
              Для начала работы и&nbsp;создания первого проекта необходимо подтвердить аккаунт по&nbsp;ссылке,
              отправленной на&nbsp;электронную почту.
            </p>
          </div>

          <FaqArticlesImageModalButton
            class="image-size-400"
            image-source="/images/faq/registratsiya-i-nachalo-raboty-4.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <p>
            Если письмо не&nbsp;пришло&nbsp;&mdash; проверьте в&nbsp;папке со&nbsp;спамом или запросите новое, нажав
            &laquo;Получить новую ссылку&raquo;.
          </p>

          <FaqArticlesImageModalButton
            image-source="/images/faq/registratsiya-i-nachalo-raboty-5.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />
        </div>

        <div class="base-content-block">
          <FaqArticlesBlockHeading
            id="dannye-akkaunta"
            class="typography__headline2"
          >
            Данные аккаунта
          </FaqArticlesBlockHeading>

          <p>
            После подтверждения не&nbsp;спешите сразу создавать первый проект. Давайте проверим данные аккаунта
            и&nbsp;заполним недостающую информацию, которая в&nbsp;дальнейшем поможет нам взаимодействовать. Перейти
            к&nbsp;ним можно в&nbsp;меню слева.
          </p>

          <div class="block">
            <h3 class="typography__headline4">Основная информация</h3>

            <div class="block-small">
              <p>
                Проверьте уже заполненные данные и&nbsp;добавьте недостающие&nbsp;&mdash; это поможет нам лучше понять
                откуда вы&nbsp;работаете и&nbsp;в&nbsp;какое время с&nbsp;вами лучше связываться.
              </p>

              <p>Корректный часовой пояс также влияет на&nbsp;вывод информации в&nbsp;данных ваших проектов.</p>
            </div>

            <FaqArticlesImageModalButton
              image-source="/images/faq/registratsiya-i-nachalo-raboty-6.jpg"
              @click="(imageSource) => (activeImageSource = imageSource)"
            />
          </div>

          <div class="block">
            <h3 class="typography__headline4">Социальные сети</h3>

            <p>Сервисы, через которые вы&nbsp;авторизовали аккаунт. При необходимости можно подключить другие.</p>

            <FaqArticlesImageModalButton
              image-source="/images/faq/registratsiya-i-nachalo-raboty-7.jpg"
              @click="(imageSource) => (activeImageSource = imageSource)"
            />
          </div>

          <div class="block">
            <h3 class="typography__headline4">Удаление аккаунта</h3>

            <p>Безвозвратное удаление аккаунта и&nbsp;всех его данных.</p>

            <FaqArticlesImageModalButton
              image-source="/images/faq/registratsiya-i-nachalo-raboty-8.jpg"
              @click="(imageSource) => (activeImageSource = imageSource)"
            />
          </div>
        </div>

        <div class="base-content-block">
          <FaqArticlesBlockHeading
            id="sozdanie-proekta"
            class="typography__headline2"
          >
            Создание проекта
          </FaqArticlesBlockHeading>

          <div class="block-small">
            <p>
              Теперь, когда мы&nbsp;зарегистрировались, подтвердили аккаунт, проверили и&nbsp;заполнили все его
              данные&nbsp;&mdash; можно переходить к&nbsp;созданию своего первого проекта!
            </p>

            <p>
              Вернитесь в&nbsp;меню слева в&nbsp;раздел &laquo;Проекты&raquo; и&nbsp;нажмите &laquo;Добавить
              проект&raquo;.
            </p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/registratsiya-i-nachalo-raboty-9.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <div class="block-small">
            <p>
              В&nbsp;появившемся окне заполните название проекта, выберите направление деятельности и&nbsp;валюту
              проекта.
            </p>

            <p>
              Ниже можно отключить ненужный вам функционал. Например, если вы&nbsp;предлагаете только услуги,
              не&nbsp;продаете товары, то&nbsp;можете отключить раздел &laquo;Товары&raquo;. Соответствующий функционал
              будет скрыт из&nbsp;главного меню CRM-системы, чтобы не&nbsp;отвлекать от&nbsp;нужного. Позже его всегда
              можно будет включить обратно.
            </p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/registratsiya-i-nachalo-raboty-10.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <div class="block-small">
            <p>
              Поздравляю, вы&nbsp;создали свой первый проект в&nbsp;MyDonut! Он&nbsp;появится на&nbsp;этой&nbsp;же
              странице. Нажмите на&nbsp;него и&nbsp;перейдите к&nbsp;<BaseLink href="/faq/categories/dannyye-proyekta"
                >настройке данных проекта</BaseLink
              >.
            </p>

            <p>Добавить еще один проект можно на&nbsp;этой&nbsp;же странице, нажав &laquo;Добавить проект&raquo;.</p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/registratsiya-i-nachalo-raboty-11.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />
        </div>
      </FaqArticlesContent>
    </div>

    <div class="page__related">
      <h2
        class="typography__headline2"
        v-html="t('pages.faq.otherArticles')"
      />

      <FaqArticlesList :articles="relatedArticles" />
    </div>
  </section>

  <LazyFaqArticlesImageModal
    v-if="isModalOpen(MODAL.FaqArticlesImage) && activeImageSource"
    :src="activeImageSource"
    @close="() => (activeImageSource = null)"
  />
</template>

<script lang="ts" setup>
const { t } = useI18n();
const { createAppLink } = useAppLink();
const { isModalOpen } = useModalStore();
const activeImageSource = ref<null | string>(null);

const breadcrumbs = [
  {
    name: t("pages.faq.title"),
    url: "/faq",
  },
  {
    name: "Основная информация",
    url: "/faq/categories/osnovnaya-informatsiya",
  },
  {
    name: "Регистрация и&nbsp;начало работы",
  },
];

const menu = [
  {
    name: "Авторизация",
    url: "avtorizatsiya",
  },
  {
    name: "Подтверждение аккаунта",
    url: "podtverzhdenie-akkaunta",
  },
  {
    name: "Данные аккаунта",
    url: "dannye-akkaunta",
  },
  {
    name: "Создание проекта",
    url: "sozdanie-proekta",
  },
];

const relatedArticles = [
  {
    name: "Что такое MyDonut",
    slug: "сhto-takoye-donut",
  },
  {
    name: "Тарифы",
    slug: "tarify",
  },
  {
    name: "Контакты",
    slug: "kontakty",
  },
];

useSeoMeta({
  title: "Регистрация и начало работы",
});
</script>

<style scoped>
.page {
  display: flex;
  flex-direction: column;
  row-gap: 40px;
}

.page__header {
  display: flex;
  flex-direction: column;
  row-gap: 40px;
}

.page__title {
  display: flex;
  flex-direction: column;
  row-gap: 24px;
}

.page__content {
  display: flex;
  flex-direction: column;
  gap: 40px;
}

@media (--xl) {
  .image-size-600 {
    max-width: 600px;
  }

  .image-size-400 {
    max-width: 400px;
  }

  .page__content {
    flex-direction: row-reverse;
    align-items: start;
  }
}

.page__related {
  display: flex;
  flex-direction: column;
  row-gap: 24px;
}
</style>
